// Данные устройств KkmServer для таблицы «Подключенные устройства».
//
// List отдаёт сохранённые настройки устройства: систему налогообложения на
// момент последнего опроса ККТ, а для ФФД 1.2 поля версии там всегда null
// (в коде списка KkmServer нет ветки для 1.2). GetDataKKT перед ответом
// перечитывает ККТ, поэтому у фискального регистратора берём его Info,
// а List остаётся запасным значением.

export const FISCAL_REGISTRAR_TYPE = 'Фискальный регистратор'

/** Нужен ли устройству запрос состояния ККТ. Неактивное не опрашиваем: ответа не будет до таймаута. */
export function needsKktState (unit) {
  return unit?.TypeDevice === FISCAL_REGISTRAR_TYPE && unit.Active === true
}

/** Версия ФФД: из состояния ККТ, иначе из списка устройств. */
export function resolveFfdVersion (unit, kktInfo) {
  return kktInfo?.FFDVersion || unit?.FFDVersion || null
}

/** Коды СНО ('0'..'5'): из состояния ККТ, иначе из списка устройств. */
export function resolveTaxVariantCodes (unit, kktInfo) {
  const raw = kktInfo?.TaxVariant || unit?.TaxVariant || ''

  return String(raw)
    .split(',')
    .map((code) => code.trim())
    .filter((code) => code !== '')
}
